import { render, staticRenderFns } from "./timeline-clinical-notes.vue?vue&type=template&id=137da6b0&scoped=true"
import script from "./timeline-clinical-notes.vue?vue&type=script&lang=js"
export * from "./timeline-clinical-notes.vue?vue&type=script&lang=js"
import style0 from "./timeline-clinical-notes.vue?vue&type=style&index=0&id=137da6b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137da6b0",
  null
  
)

export default component.exports